export default "__VITE_ASSET__H0YMcUT8__"